import { createSelector } from 'reselect'
import * as SelectorUtils from './utils'
import { DefaultState } from '../reducers/DefaultState'

export const DefaultBudgetSubscribersState = {
  ...DefaultState
}

const getBudgetSubscribersState = (state) => {
  return (state || {}).budgetSubscribers || null
}

const getSelectedMetricDate = createSelector(
  [getBudgetSubscribersState],
  (state) => {
    return (state || {}).selectedMetricDate || null
  }
)

const getBudgetSubscribersDetails = createSelector(
  [getBudgetSubscribersState, getSelectedMetricDate],
  (budgetSubscribersState, metricDate) => {
    return budgetSubscribersState ? budgetSubscribersState.byMetricDate[metricDate] : null
  }
)

const getBudgetSubscribersDetailsState = createSelector(
  [getBudgetSubscribersDetails],
  (state) => {
    return (state || {}).budgetSubscribers || DefaultBudgetSubscribersState
  }
)

const getBudgetSubscribersExportState = createSelector(
  [getBudgetSubscribersState],
  (state) => {
    return (state || {}).export || DefaultBudgetSubscribersState
  }
)

const makeBudgetSubscribersSelector = () => {
  return createSelector(
    [getBudgetSubscribersDetailsState],
    (details) => {
      if (details) {
        return {
          isFetching: SelectorUtils.isFetching(details),
          error: details.error,
          details: details.details
        }
      }
    }
  )
}

const makeBudgetSubscribersExportStateSelector = () => {
  return createSelector(
    [getBudgetSubscribersExportState],
  (details) => {
    return {
      isFetching: details.isFetching,
      error: details.error,
      details: details.details
    }
  }
  )
}

export {
  makeBudgetSubscribersSelector,
  makeBudgetSubscribersExportStateSelector
}
